import { DateTimeType } from './dateTypes';
import { Location } from './location';
import { z } from 'zod';

export const TripData = z.object({
    /** Trip description */
    description: z.string().nullish(),
    /** The location where the traveler started */
    locationFrom: Location.nullish(),
    /** The location where the traveler was going to */
    locationTo: Location.nullish(),
    /** Datetime when trip started */
    startedOn: DateTimeType.nullish(),
    /** Datetime when trip ended */
    endedOn: DateTimeType.nullish(),
});
export type TripData = z.infer<typeof TripData>;
